import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios';
import {api_base_url, base_url} from '../common/Constants';
 
class Slider extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            banners : this.props.banners,
            loading : 0
        }

        
        

    }
    componentDidMount()
    { 
        
            const script = document.createElement("script");
            script.src   = base_url+"assets/js/loadSlider.js";  
            script.async = true;
            document.body.appendChild(script);
 
            script.onload = () => {
            if (window.loadSlider && this.state.loading == 0 && this.props.banners.length > 0) {
            window.loadSlider();
            this.setState({loading:1})
            }
            };
      
         
    }
    componentDidUpdate()
    { 
      
            const script = document.createElement("script");
            script.src   = base_url+"assets/js/loadSlider.js";  
            script.async = true;
            document.body.appendChild(script);
 
            script.onload = () => {
            if (window.loadSlider && this.state.loading == 0 && this.props.banners.length > 0) {
            window.loadSlider();
            this.setState({loading:1})
            }
            };
      //  this.setState({loading: 0});
         
    }
     
    render()
    { 

       
    return (
          <div class="overflow-hidden">
            <div class="ul-container">
                <section class="ul-banner">
                    <div class="ul-banner-slider-wrapper">
                        <div class="ul-banner-slider swiper">
                            <div class="swiper-wrapper">
                                
                                {this.state.banners.map((item,key)=>(
                                <div class="swiper-slide ul-banner-slide">
                                    <div class="ul-banner-slide-img">
                                        <img src={item.image} alt={item.title} />
                                    </div>
                                    <div class="ul-banner-slide-txt">
                                        <span class="ul-banner-slide-sub-title">{item.subtitle}</span>
                                        <h1 class="ul-banner-slide-title">{item.title}</h1>
                                  {/***<p class="ul-banner-slide-price">Starting From <span class="price">$129</span></p> */}
                                  {item.title && (
                                        <Link to="shop" class="ul-btn">SHOP NOW <i class="flaticon-up-right-arrow"></i></Link>
                                  )}
                                    </div>
                                </div>

                                ))};
 

                                 
                            </div>

                             
                            <div class="ul-banner-slider-nav-wrapper">
                                <div class="ul-banner-slider-nav">
                                    <button class="prev"><span class="icon"><i class="flaticon-down"></i></span></button>
                                    <button class="next"><span class="icon"><i class="flaticon-down"></i></span></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ul-banner-img-slider-wrapper">
                        <div class="ul-banner-img-slider swiper">
                            <div class="swiper-wrapper">
                                 {this.state.banners.map((item,key)=>(
                                <div class="swiper-slide">
                                       <img src={item.image} alt={item.title} />
                                </div>
                                ))};
                                 
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

}

export default Slider;